"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Toilet(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M17 2c1.369 0 2.382 1.043 3.016 2.311C20.649 5.578 21 7.208 21 9c0 1.792-.351 3.422-.984 4.689C19.382 14.957 18.369 16 17 16h-2v6H3V9c0-1.792.351-3.422.984-4.689C4.618 3.043 5.631 2 7 2zm-2.826 2H7c-.288 0-.774.302-1.227 1.205C5.321 6.108 5 7.479 5 9v2h1v2H5v7h8v-7h-1v-2h1V9c0-1.792.351-3.422.984-4.689.055-.11.129-.206.19-.311zM17 4c-.288 0-.774.302-1.227 1.205C15.321 6.108 15 7.479 15 9s.321 2.892.773 3.795C16.226 13.698 16.712 14 17 14c.288 0 .774-.302 1.227-1.205.452-.903.773-2.274.773-3.795s-.321-2.892-.773-3.795C17.774 4.302 17.288 4 17 4zm-7 7v2H8v-2h2zm7-4c.553 0 1 .896 1 2s-.447 2-1 2c-.553 0-1-.896-1-2s.447-2 1-2z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Toilet;
